import { exportExcel } from "@api/stores/warehouses/batches/exportExcel/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { IWarehouseBatchesResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IWarehouseBatchesResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.warehouses.batches");

const getApis = createGetApi<
  IApiResponse<IWarehouseBatchesResponse>,
  IPathByIdParam,
  object
>("stores.warehouses.batches");

export const batches = {
  ...getAllApis,
  ...getApis,
  exportExcel,
};
